import { render, staticRenderFns } from "./CarSection.vue?vue&type=template&id=5c6af19e&scoped=true&"
import script from "./CarSection.vue?vue&type=script&lang=js&"
export * from "./CarSection.vue?vue&type=script&lang=js&"
import style0 from "./CarSection.vue?vue&type=style&index=0&id=5c6af19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6af19e",
  null
  
)

/* custom blocks */
import block0 from "./CarSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VSwitch,VTextField})
